/*
 * @Author: cc
 * @LastEditTime: 2022-06-17 17:21:06
 */
import { useEffect, useState, useRef } from "react";
// import { IsPc } from "../utils/index";
import "moment/locale/zh-cn";
import { useHistory, useLocation } from "react-router-dom";
import { useQuery } from "src/utils";
import { get } from "src/component/fetch"
import PDFViewer from 'react-pdf-js';
import { LeftOutline, RightOutline } from 'antd-mobile-icons'
import "./index.scss"
const Index = () => {
  const query = useQuery()
  const history = useHistory();
  const trainFileLongUrl = query.get('trainFileLongUrl') || ''
  const [page, setPage] = useState(1)
  const [pages, setPages] = useState(1)
  const onDocumentLoadSuccess = (pages: number) => {
    setPages(pages)
  }
  useEffect(() => {
  }, [])
  return (
    <div className="pdfWrapper">
    <div style={{ width: '100%', height: '500px' }} className="pdfBody">
      <PDFViewer file={trainFileLongUrl} page={page} onDocumentComplete={onDocumentLoadSuccess} />
      <p style={{textAlign:'center',position:"absolute",bottom:"0",left:"0",width:"100%",display:"flex",justifyContent:"space-between",alignItems:"center",padding:"0 20px"}}>
        <LeftOutline className="left" onClick={() => {
          if (page <= 1) {
            return
          }
          setPage(page - 1)
        }} />
        <span>{page + ' / ' + pages}</span>
        <RightOutline className="right" onClick={() => {
          if (page >= pages) {
            return
          }
          setPage(page + 1)
        }} />
      </p>
    </div>
    </div>
  );
};
export default Index;
